export default __webpack_public_path__ + "static/media/hand-touching.29ad913d.jpg";